import { Field, Input, InputPhone } from '@welbe/design-system';
import { EmployeeSection } from '../../components/EmployeeSection';
import { useEmployee } from '../../Employee.hooks';
import { Controller } from 'react-hook-form';

export const ContactData = ({
	errors,
	disabled,
}: {
	errors: string[];
	disabled?: boolean;
}) => {
	const { methods } = useEmployee();
	const { control, register } = methods;

	return (
		<EmployeeSection
			id="contact-data"
			title="Datos de contacto"
			description="Utilizaremos esta información para enviar notificaciones a los usuarios al utilizar sus beneficios de salud"
		>
			<Field.Root
				required
				invalid={errors.includes('alternativeEmail')}
				readOnly={disabled}
			>
				<Field.Label>
					Correo electrónico <Field.RequiredIndicator />
				</Field.Label>
				<Input
					type="email"
					placeholder="Escribe el correo electrónico"
					{...register('alternativeEmail')}
				/>
			</Field.Root>

			<Controller
				name="alternativePhone"
				control={control}
				render={({ field }) => (
					<InputPhone
						readOnly={disabled}
						value={field.value}
						onChange={(value: any) => {
							field.onChange(value);
						}}
					/>
				)}
			/>
		</EmployeeSection>
	);
};
